import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import type { App } from 'vue'

import { CookieConsentKey } from '@/composables/useCookieConsent'

export default {
  install(app: App) {
    app.provide(CookieConsentKey, CookieConsent)
  }
}
